module.exports = __webpack_public_path__ + "img/_qft-dagger_.a8bcc9fd.svg";